import {Empty} from 'antd'
import {feed_fetchFeedByContainer_Api} from 'apis'
import EmptyHolder from 'components/EmptyHolder'
import _ from 'lodash'
import CustomLazyPaginationWrapper from 'modules/asyncCache/components/CustomLazyPaginationWrapper'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useMemo} from 'react'
import {feedContentTypes, isValidContentType} from 'views/Feed/Feed'
import {renderFeedByType} from 'views/MainPage/functions/renderFeedItem'
import renderPagingLoading from 'views/MainPage/functions/renderPagingLoading'
import {deepTranslate} from 'views/Shared'
import ContentTypeSelectable from 'views/Shared/components/ContentTypeSelectable'

const renderItem = (item, index) => (
  <div className="mb-3">{renderFeedByType('all')(item, index)}</div>
)

const OrganizationFeeds = ({
  id,
  className,
  type = 'organization',
  content_type,
}) => {
  const apiInfo = feed_fetchFeedByContainer_Api

  const lookupKey = [
    apiInfo.path.replace(':id', id).replace(':prop', type),
    `content-type=${content_type}`,
  ].join('/')

  const getValues = useCallback(
    () =>
      _.isEmpty(content_type)
        ? {}
        : {
            content_type,
          },
    [content_type]
  )

  return (
    <div className={className}>
      <CustomLazyPaginationWrapper
        id={lookupKey}
        query={{
          ':id': id,
          ':prop': type,
        }}
        values={getValues()}
        apiInfo={apiInfo}
        alwaysVisible={true}
        renderItem={renderItem}
        renderLoading={renderPagingLoading}
        renderEmpty={() => <EmptyHolder />}
      />
    </div>
  )
}

export const OrganizationFeedsByContentType = ({
  id,
  type,
  className,
  renderItem = () => <Empty />,
  options = feedContentTypes,
}) => {
  const t = useTranslate()

  const items = useMemo(() => {
    return options.map(deepTranslate(t))
  }, [options, t])

  const render = useCallback(
    (selected, params) => {
      return renderItem({
        ...{
          id,
          type,
          className,
        },
        ...params,
        ...(isValidContentType(selected) ? { content_type: selected } : {}),
      })
    },
    [renderItem, id, type, className]
  )

  return (
    <ContentTypeSelectable
      options={items}
      className="mx-3">
      {([current], params) => render(current, params)}
    </ContentTypeSelectable>
  )
}

export default OrganizationFeeds
